

















































































































import { genPostReq } from "@/services/checklist.service";
import ResultSlot from "@/components/inspections/ResultSlot.vue"
import ResultModal from "@/components/inspections/ResultModal.vue"

export default {
  data() {
    return {
      initLoaded: true,
      search: null,
      activeTreeRow: {},
      the_task: null,
      tasks: [],
      open: [],
      lblTasks: "",
      loadingResult: false,
      //results: [],
      treeData: [],
      selectedResultEntry: {},
      showResultEdit: false
    };
  },
  components: {
    ResultSlot,
    ResultModal
  },
  filters: {
    trim: function(string) {
      if (string) {
        return string.trim();
      }
    }
  },

  computed: {
    results() {
      if (this.$store.state.che_results) {
        return this.$store.state.che_results
      }
      return []
    },
    filter_tree() {
      return this.caseSensitive
        ? (item, search, textKey) => item[textKey].indexOf(search) > -1
        : undefined;
    },
    inspections() {
      return this.$store.state.che_inspections;
    },
    inspection() {
      if (this.$store.state.che_inspection) {
        return this.$store.state.che_inspection;
      }
      return {};
    },
  
    selectedComponent() {
      if (this.activeTreeRow.length > 0) {
        return this.activeTreeRow[0];
      }
      return null;
    },
    sim_inspections() {
      return this.$store.state.che_same_inspections
    },
    tasks_list() {
      let m = [];
      if (
        this.activeTreeRow.length > 0 &&
        this.activeTreeRow[0].tasks.length > 0
      ) {
        for (let task of this.activeTreeRow[0].tasks)
          m.push({ text: task.name.de, value: task._id });
      }
      return m;
    }
  },
  methods: {


    getComponentEntry(id, children) {
      for (let k of children) {
        if (k.cid == id) {
          return k
        }
        if (k.children.length > 0) {
          return this.getComponentEntry(id, k.children)
        }
      }
    },
    onResultEdit(item) {
      item.componentId = this.activeTreeRow[0].cid
      item.inspectionId = this.$store.state.che_inspection._id
      item.taskId = this.the_task
      this.selectedResultEntry = item
      this.showResultEdit = true
    },
    dialogResultEditClosed() {
      this.showResultEdit = false
    },
    loadResults(task_id) {
      const data = {
        inspectionId: this.inspection._id,
        componentId: this.activeTreeRow[0].cid,
        taskId: task_id,
        projectId: this.$store.state.che_projectId
      };
      this.loadingResult = true;

      genPostReq("inspect-editor", "get-results", data)
        .then(resp => {
          this.loadingResult = false;
          this.$store.state.che_results = resp.data.docs
        })
        .catch(e => {
          //this.$store.dispatch('api_error', e)
        });
    },
    selTask() {
      this.$store.commit('set_inspection_url', { comp: this.activeTreeRow[0].cid,  task: this.the_task } )
      //this.$router.push({ name: 'inspection', params: { comp: this.activeTreeRow[0].cid,  task: this.the_task } }) 
      this.loadResults(this.the_task);
    },
    selInspection() {

    },
    openTreeItem(item) {

      if (item.length == 0) {
        return
      }
      this.activeTreeRow = item;

      if (item[0]) {
        let task_id;

        if (item[0].tasks.length > 0) {
          task_id = item[0].tasks[0]._id;
          this.the_task = task_id;
          this.loadResults(task_id);
          this.$store.commit('set_inspection_url', { comp: this.activeTreeRow[0].cid,  task: this.the_task } )
        }
         
      }


    }
  },
  mounted() {
    this.$store.state.che_inspection = {};
    this.$store.state.cl_uid = this.$route.params.uid;
    this.$store.state.headerTitle = "Inspektionen";

    this.$store.state.initParams = {...this.$route.params}

    const ref = this
    genPostReq("inspect-editor", "get-inspection", {
      uid: this.$store.state.cl_uid, 
      projectId: this.$store.state.che_projectId
    })
      .then(resp => {
        this.$store.state.che_inspection = resp.data.inspection;
        this.$store.state.che_same_inspections = resp.data.inspections;
        this.treeData = this.$store.getters.inspectionComponents; 

        console.log( this.$store.state.che_inspection, this.treeData )

        if (this.$store.state.initParams.comp) {
          const comp_entry = this.getComponentEntry(this.$store.state.initParams.comp, this.treeData)
          if (comp_entry && this.$store.state.initParams.task) {
            this.activeTreeRow = [comp_entry]
            this.the_task = this.$store.state.initParams.task
            console.log("activeTreeRow", this.activeTreeRow)

            
            this.loadResults(this.the_task);
          }
        }
      })
      .catch(e => {
        //this.$store.dispatch('api_error', e)
      });
  },
  created() {}
};
